<script>
import ActionBar from '@/components/core/ActionBar.vue';

export default {
  extends: ActionBar,
  data() {
    return {
      resourceName: 'Subscription',
      urlFragment: 'email-reports',
    };
  },
};
</script>

<style></style>
